import { ReactComponent as AvivaIcon } from "@assets/icons/aviva_logo.svg";
import { ReactComponent as NewIrelandIcon } from "@assets/footer-icons/New Ireland Black.svg";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import { ReactComponent as PlusIcon } from "@assets/icons/plus.svg";
import { ReactComponent as ZurichVertical } from "@assets/icons/zurich_vertical.svg";
import { ReactComponent as MinusIcon } from "@assets/icons/minus.svg";
import PennyMobileView from "@assets/illustrations/penny_mobile_view.webp";
import PennySpaceFactPensions from "@assets/illustrations/penny_space_fact_pensions.jpeg";
import PennySpaceProviderImage from "@assets/illustrations/penny_space_provider.jpeg";
import SectionHeader from "@components/Section/SectionHeader";
import { Collapse } from "@mantine/core";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import ImageWithFallback from "@components/Image/ImageWithFallback";

type DashboardPennySpaceProps = {
  pension_values?: {
    retirement: number;
    contribution: number;
  };
};

const DashboardPennySpace: React.FC<DashboardPennySpaceProps> = () => {
  const [oneq, setOneq] = useState(false);
  const [twoq, setTwoq] = useState(false);
  const [threeq, setThreeq] = useState(false);
  const [fourq, setFourq] = useState(false);
  const [fiveq, setFiveq] = useState(false);
  const [showProviderDetails, setShowProviderDetails] = useState(false);
  const [showFactDetails, setShowFactDetails] = useState(false);

  return (
    <>
      <div className="flex flex-col gap-y-6">
        <SectionHeader label="Penny Space" />

        <div className="px-4 lg:px-[80px] w-full flex flex-col lg:flex-row items-stretch gap-y-[23px] lg:gap-y-0 lg:gap-x-[23px]">
          {/* {pension_values?.retirement &&
            pension_values?.retirement > 0 &&
            pension_values?.contribution &&
            pension_values?.contribution > 0 ? (
            <div className="border flex-1 flex flex-col border-pn_gray-200 bg-pn_white rounded-2xl">
              <div className="flex p-6 pb-0 flex-col gap-y-[14px]">
                <div className="border border-pn_gray-200 rounded-xl p-4 flex flex-col gap-y-2">
                  <span className="text-pn-caption-medium bg-[#F4E34E] w-fit uppercase">
                    Enjoy in retirement
                  </span>
                  <div className="flex">
                    <span className="text-pn-title-regular lg:text-pn-large-title">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(pension_values.retirement)}{" "}
                      <sub className="text-pn-callout-regular text-pn_gray-600 bottom-0">
                        per month
                      </sub>
                    </span>
                  </div>
                </div>

                <div className="border border-pn_gray-200 rounded-xl p-4 flex flex-col gap-y-2">
                  <span className="text-pn-caption-medium bg-[#F4E34E] w-fit uppercase">
                    When you save today
                  </span>
                  <div className="flex">
                    <span className="text-pn-title-regular lg:text-pn-large-title">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(pension_values.contribution)}{" "}
                      <sub className="text-pn-callout-regular text-pn_gray-600 bottom-0">
                        per month
                      </sub>
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-6 flex flex-col gap-y-4 grow-[1]">
                <span className="hidden lg:block text-pn-title-regular text-pn_gray-950">
                  Your pension can look like this when you retire, what are you
                  waiting for?
                </span>
                <span className="text-pn-title-regular block lg:hidden text-pn_gray-950">
                  This is what your pension can look when you retire
                </span>
                <span className="text-pn-callout-regular text-pn_gray-600">
                  Get an idea of what your pension could look like and how to
                  start in a click
                </span>
              </div>

              <div className="px-6 pb-6">
                <button className="btn-primary-sm-40">Get Started</button>
              </div>
            </div>
          ) : null} */}

          <div className="border flex-1 flex flex-col border-pn_gray-200 bg-pn_white rounded-2xl overflow-hidden">
            <div className="relative w-full aspect-video h-[232px]">
              <div 
                className="w-full absolute top-0 left-0 h-[100%] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${PennySpaceProviderImage})`,
                  backgroundColor: '#F3EFEA' // fallback color
                }}
              />
              <div className="absolute left-1/2 transform -translate-x-1/2 top-1/2 -translate-y-1/2 flex items-center justify-center">
                <div className="w-[64px] h-[64px] relative -right-[17px] border rounded-full border-pn_gray-200 bg-white flex items-center justify-center">
                  <ZurichVertical />
                </div>
                <div className="w-[64px] relative h-[64px] border rounded-full border-pn_gray-200 bg-white flex items-center justify-center">
                  <AvivaIcon />
                </div>
                <div className="w-[64px] relative right-[17px] h-[64px] border rounded-full border-pn_gray-200 bg-white flex items-center justify-center">
                  <NewIrelandIcon />
                </div>
              </div>
            </div>
            <div className="p-6 flex flex-col gap-y-4 grow-[1]">
              <span className="text-pn-title-regular text-pn_gray-950">
                Choose a provider that best suits your values
              </span>
              <Collapse in={showProviderDetails}>
                <span className="text-pn-callout-regular text-pn_gray-600">
                  Penny Partners with multiple providers to help you pick the one
                  that best suits your needs
                </span>
              </Collapse>
            </div>
            <div className="pb-6 px-6">
              <button 
                className="btn-secondary-sm-40"
                onClick={() => setShowProviderDetails(prev => !prev)}
              >
                Read More
              </button>
            </div>
          </div>
          <div className="border flex-1 flex flex-col border-pn_gray-200 bg-pn_white rounded-2xl overflow-hidden">
            <div className="relative w-full aspect-video h-[232px]">
              <div 
                className="w-full absolute top-0 left-0 h-[100%] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${PennySpaceFactPensions})`,
                  backgroundColor: '#F3EFEA' // fallback color
                }}
              />
              <div className="absolute top-6 left-[22px] rounded-lg bg-pn_black text-pn_white py-1 px-2 flex items-center justify-center">
                <span className="text-pn-callout-emphasis">Fact</span>
              </div>
              <div className="absolute left-1/2 transform -translate-x-1/2 top-1/2 -translate-y-1/2 flex items-center justify-center">
                <span className="text-pn-large-title !text-[82px] text-pn_white">
                  42%
                </span>
                <sup className="-top-10">
                  <PennyIcon
                    className="[&>path]:fill-pn_white"
                    width={32}
                    height={36}
                  />
                </sup>
              </div>
            </div>
            <div className="p-6 flex flex-col gap-y-4 grow-[1]">
              <span className="text-pn-title-regular text-pn_gray-950">
                42% of Irish woman don't have a pension
              </span>
              <Collapse in={showFactDetails}>
                <span className="text-pn-callout-regular text-pn_gray-600">
                  Every year this number increases and your friends and family are
                  probably part of this number too. Let then know.
                </span>
              </Collapse>
            </div>
            <div className="pb-6 px-6">
              <button 
                className="btn-secondary-sm-40"
                onClick={() => setShowFactDetails(prev => !prev)}
              >
                Read More
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="py-4 md:py-[80px] px-4 lg:px-[80px]">
        <div className="bg-pn_paper-3 border border-pn_gray-200 rounded-2xl flex items-center justify-center gap-x-[10%] pt-[32px] pb-[48px] md:pt-0 md:pb-0 px-6 md:px-[5%]">
          <div className="max-w-[439px] w-full pt-[68px] hidden md:block">
            <ImageWithFallback
              src={PennyMobileView || "/placeholder.svg"}
              alt="penny_mobile_friendly"
              className="w-full h-full"
              width="100%"
              height="auto"
              loading="lazy"
            />
          </div>
          <div className="flex flex-col gap-y-[18px] max-w-full md:max-w-[452px] w-full">
            <div className="bg-pn_black rounded-lg py-1 px-2 w-fit">
              <span className="text-pn_white text-pn-callout-emphasis">
                Go Beyond
              </span>
            </div>
            <div className="flex flex-col gap-y-4">
              <span className="text-pn-large-title text-pn_gray-950">
                Come as you are, as you were As you want it to be
              </span>
              <span className="text-pn-body-large-regular text-pn_gray-950">
                Penny is available everywhere. You can start here, continue
                there, and be anywhere.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="pb-[95px] md:pb-[80px] flex flex-col gap-y-0 lg:gap-y-6">
        <SectionHeader label="We're here to help" />

        <div className="px-4 lg:px-[80px] w-full flex flex-col">
          <div className="border-b-2 border-pn_gray-200 flex-col items-center w-full">
            <button
              onClick={() => setOneq((prev) => !prev)}
              className="justify-between flex py-6 w-full items-center gap-x-6"
            >
              <span className="text-pn-title-regular text-left md:text-pn-large-title text-pn_gray-950 flex-1">
                What is Penny?
              </span>
              <div
                className={twMerge(
                  oneq ? "bg-pn_gray-200" : "bg-[#F4E34E]",
                  "w-10 h-10 rounded-full flex items-center justify-center"
                )}
              >
                {oneq ? (
                  <MinusIcon width={16} height={16} />
                ) : (
                  <PlusIcon width={16} height={16} />
                )}
              </div>
            </button>

            <Collapse in={oneq}>
              <div className="max-w-[845px] pb-10 w-full text-pn_gray-950 text-pn-body-large-regular">
                <span>
                  Penny is a 100% online platform that connects customers with
                  the pension products and financial advice they need. Through
                  our simple online process you can apply, view and manage your
                  pension, all from the comfort of your own phone.
                </span>
              </div>
            </Collapse>
          </div>

          <div className="border-b-2 border-pn_gray-200 flex-col items-center w-full">
            <button
              onClick={() => setTwoq((prev) => !prev)}
              className="justify-between flex py-6 w-full items-center gap-x-6"
            >
              <span className="text-pn-title-regular text-left md:text-pn-large-title text-pn_gray-950 flex-1">
                How do I get started with Penny?
              </span>
              <div
                className={twMerge(
                  twoq ? "bg-pn_gray-200" : "bg-[#F4E34E]",
                  "w-10 h-10 rounded-full flex items-center justify-center"
                )}
              >
                {twoq ? (
                  <MinusIcon width={16} height={16} />
                ) : (
                  <PlusIcon width={16} height={16} />
                )}
              </div>
            </button>

            <Collapse in={twoq}>
              <div className="max-w-[845px] pb-10 w-full text-pn_gray-950 text-pn-body-large-regular">
                <span>
                  Signing up with Penny is easy - just create an account,
                  provide some basic details and receive your recommendation.
                  You can pick from a range of pension plans, adjust as needed
                  and get regular check-ins with your personal financial
                  advisor.
                </span>
              </div>
            </Collapse>
          </div>

          <div className="border-b-2 border-pn_gray-200 flex-col items-center w-full">
            <button
              onClick={() => setThreeq((prev) => !prev)}
              className="justify-between flex py-6 w-full items-center gap-x-6"
            >
              <span className="text-pn-title-regular text-left md:text-pn-large-title text-pn_gray-950 flex-1">
                How long does it take complete?
              </span>
              <div
                className={twMerge(
                  threeq ? "bg-pn_gray-200" : "bg-[#F4E34E]",
                  "w-10 h-10 rounded-full flex items-center justify-center"
                )}
              >
                {threeq ? (
                  <MinusIcon width={16} height={16} />
                ) : (
                  <PlusIcon width={16} height={16} />
                )}
              </div>
            </button>

            <Collapse in={threeq}>
              <div className="max-w-[845px] pb-10 w-full text-pn_gray-950 text-pn-body-large-regular">
                <span>
                  Your customised pension will be ready within 24 hours, and
                  once selected, we'll have your pension up and running in two
                  days.
                </span>
              </div>
            </Collapse>
          </div>

          <div className="border-b-2 border-pn_gray-200 flex-col items-center w-full">
            <button
              onClick={() => setFourq((prev) => !prev)}
              className="justify-between flex py-6 w-full items-center gap-x-6"
            >
              <span className="text-pn-title-regular text-left md:text-pn-large-title text-pn_gray-950 flex-1">
                What documents are necessary?
              </span>
              <div
                className={twMerge(
                  fourq ? "bg-pn_gray-200" : "bg-[#F4E34E]",
                  "w-10 h-10 rounded-full flex items-center justify-center"
                )}
              >
                {fourq ? (
                  <MinusIcon width={16} height={16} />
                ) : (
                  <PlusIcon width={16} height={16} />
                )}
              </div>
            </button>

            <Collapse in={fourq}>
              <div className="max-w-[845px] pb-10 w-full text-pn_gray-950 text-pn-body-large-regular">
                <span>
                  Once your pension recommendation is confirmed, you'll be
                  prompted to upload two documents: proof of PPSN (Personal
                  Public Service Number) and proof of identity (i.e. Passport,
                  Drivers Licence, National Identity can). <br /> <br /> To
                  finalise the process, simply review, sign and submit to have
                  your pension processed.
                </span>
              </div>
            </Collapse>
          </div>

          <div className="border-b-2 border-pn_gray-200 flex-col items-center w-full">
            <button
              onClick={() => setFiveq((prev) => !prev)}
              className="justify-between flex py-6 w-full items-center gap-x-6"
            >
              <span className="text-pn-title-regular text-left md:text-pn-large-title text-pn_gray-950 flex-1">
                Is Penny secure?
              </span>
              <div
                className={twMerge(
                  fiveq ? "bg-pn_gray-200" : "bg-[#F4E34E]",
                  "w-10 h-10 rounded-full flex items-center justify-center"
                )}
              >
                {fiveq ? (
                  <MinusIcon width={16} height={16} />
                ) : (
                  <PlusIcon width={16} height={16} />
                )}
              </div>
            </button>

            <Collapse in={fiveq}>
              <div className="max-w-[845px] pb-10 w-full text-pn_gray-950 text-pn-body-large-regular">
                <span>
                  Penny takes your security very seriously. We are triple
                  regulated -by the Central Bank of Ireland, the Pensions
                  Authority of Ireland and each of our pension partners'
                  products. We follow information security best practices,
                  overseen by our Chief of Compliance to confirm what we're
                  doing is effective Need more help? We get it: you've got more
                  questions and now you need a human. Contact us at{" "}
                  <Link
                    to={"mailto:hey@iam-penny.com"}
                    className="text-pn-body-large-link text-pn_cyan-500"
                  >
                    hey@iam-penny.com
                  </Link>{" "}
                  or call us on{" "}
                  <Link
                    to="tel:+335879119440"
                    className="text-pn-body-large-link text-pn_cyan-500"
                  >
                    +335 87 9119 440
                  </Link>{" "}
                  (a real human will answer)
                </span>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardPennySpace;
